<template>
  <div class="hero-video">
    <video
      ref="video"
      class="hero-video__video"
      :autoplay="autoplay"
      loop
      muted
      playsinline
      :src="item.video"
      type="video/mp4">
      {{ tStatic('videoFormatNotSupported') }}
    </video>
    <button
      v-show="paused"
      class="hero-video__action"
      @click="toggleVideo(true)"
      @mouseenter="playIcon = 'play-darker'"
      @mouseleave="playIcon = 'play'">
      <oie-use-svg :svg="playIcon" :height="size" :width="size"></oie-use-svg>
    </button>
    <button
      v-show="playing"
      class="hero-video__action"
      @click="toggleVideo(false)"
      @mouseenter="pauseIcon = 'pause-darker'"
      @mouseleave="pauseIcon = 'pause'">
      <oie-use-svg :svg="pauseIcon" :height="size" :width="size"></oie-use-svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      playing: true,
      playIcon: 'play',
      pauseIcon: 'pause'
    }
  },
  computed: {
    autoplay() {
      // Temporarily disable nice-to-have toggle of autoplay. Needs further investigation to work on mobiles
      // const setting = window.matchMedia('(prefers-reduced-motion: reduce)')
      // return !((setting && setting.matches))
      return true
    },
    paused() { return !this.playing },
    size() {
      return this.mq('to-large') ? 30 : 40
    }
  },
  mounted() {
    this.playing = !!this.autoplay
  },
  methods: {
    toggleVideo(play) {
      this.playing = play
      play ? this.$refs.video.play() : this.$refs.video.pause()
    }
  }
}
</script>

<style lang="scss">
.hero-video__video::-webkit-media-controls {
  display: none;
}

.hero-video__action {
  @include reset-button;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  padding: measure(half);

  @include media(to-large) {
    display: flex;
    padding: measure(eighth);
  }
}
</style>
